module.exports = __webpack_public_path__ + "img/Logo-SonPhat-Trang.ab1acda8.png";